import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import Layout from '../layout'
import api from '@/api/api'
import {getMerchantBasic, getFlag} from "@/utils/auth";
let merchantType = JSON.parse(localStorage.getItem('merchantBasic'))? JSON.parse(localStorage.getItem('merchantBasic')).type:''
let merchantNumber = localStorage.getItem('merchantNumber')? localStorage.getItem('merchantNumber'):''
let virtualNumber = JSON.parse(sessionStorage.getItem('virtualNumber'))? JSON.parse(sessionStorage.getItem('virtualNumber')).code.split(','):[]
let virtualNumber2 = JSON.parse(sessionStorage.getItem('virtualNumber2'))? JSON.parse(sessionStorage.getItem('virtualNumber2')).code.split(','):[]
Vue.use(VueRouter)

let constantRoutesArray = []
if (getFlag() === 'on') {
constantRoutesArray = [
  {
    path: '/certification',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'certification',
        component: () => import('@/views/certification'),
      },
      {
        path: 'audit',
        name: 'audit',
        component: () => import('@/views/certification/audit'),
      },
      {
        path: 'step',
        name: 'step',
        component: () => import('@/views/certification/step'),
      }
    ]
  },
  {
    path: '/wallet',
    component: Layout,
    children: [
      {
        path: '',
        name: 'wallet',
        component: () => import('@/views/wallet'),
        meta: { title: 'router.wallet', icon: 'multiwallet' },
        api: [api.wallet.multiAccount]
      },
      {
        path: 'detail',
        name: 'wallet_detail',
        component: () => import('@/views/wallet/list'),
        meta: { title: 'router.walletDetail', activeMenu: '/wallet' },
        hidden: true
      },
      {
        path: 'abroadList',
        name: 'wallet_detail',
        component: () => import('@/views/wallet/abroadList'),
        meta: { title: 'router.walletDetail', activeMenu: '/wallet' },
        hidden: true
      }
    ]
  },
  {
    path: '/subMerchant',
    component: Layout,
    children: [
      {
        path: '',
        name: 'subMerchant',
        component: () => import('@/views/subMerchant'),
        meta: { title: 'router.subMerchant', icon: 'sub', noCache: true},
        api: [api.agent.search]
      }
    ]
  },
  {
    path: '/transactionManage',
    name: 'transactionManage',
    component: Layout,
    meta: { title: 'router.transactionManage', icon: 'envelope' },
    children: [
      {
        path: 'recharge',
        name: 'recharge',
        component: () => import('@/views/transactionManage/recharge'),
        meta: { title: 'router.recharge' },
        api: [api.transaction.depositsSearch]
      },
      {
        path: 'withdrawal',
        name: 'withdrawal',
        component: () => import('@/views/transactionManage/withdrawal'),
        meta: { title: 'router.withdrawal' },
        api: [api.transaction.withdrawSearch]
      },
    ],
    hiddenNumber: true,
  },
  {
    path: '/purchasePayment',
    component: Layout,
    children: [
      {
        path: '',
        name: 'purchasePayment',
        component: () => import('@/views/purchasePayment'),
        meta: { title: 'router.purchasePayment', icon: 'purchase' },
        api: merchantType === 'proxy_crossing' ? [api.agent.transactionList] : [api.purchase.transactionList]
      },
      {
        path: 'detail',
        name: 'purchasePaymentDetail',
        component: () => import('@/views/purchasePayment/detail'),
        meta: { title: 'purchasePaymentDetail', activeMenu: '/purchasePayment' },
        hidden: true
      },
      {
        path: 'order',
        name: 'purchasePaymentOrder',
        component: () => import('@/views/purchasePayment/order'),
        meta: { title: 'router.purchasePaymentOrder', activeMenu: '/purchasePayment'},
        hidden: true
      },
      {
        path: 'initiate',
        name: 'initiate',
        component: () => import('@/views/purchasePayment/initiate'),
        meta: { title: 'router.initiate', activeMenu: '/purchasePayment' },
        hidden: true
      },
    ]
  },
  {
    path: '/receivingSettlement',
    component: Layout,
    meta: { title: 'router.receivingSettlement', icon: 'ChinaY' },
    children: [
      {
        path: '',
        name: 'receivingSettlement',
        component: () => import('@/views/receivingSettlement'),
        meta: { title: 'router.receivingSettlement' },
        api: merchantType === 'proxy_crossing' ? [api.agent.receiptAll] : [api.receiving.receiptAll]
      },
      {
        path: 'order',
        name: 'receivingSettlementOrder',
        component: () => import('@/views/receivingSettlement/order'),
        meta: { title: 'router.receivingSettlementOrder', activeMenu: '/receivingSettlement' },
        hidden: true
      },
      {
        path: 'batch',
        name: 'receivingSettlementBatch',
        component: () => import('@/views/receivingSettlement/batch'),
        meta: { title: 'router.receivingSettlementBatch', activeMenu: '/receivingSettlement' },
        hidden: true
      },
      {
        path: 'detail',
        name: 'receivingSettlementDetail',
        component: () => import('@/views/receivingSettlement/detail'),
        meta: { title: 'router.receivingSettlementDetail', activeMenu: '/receivingSettlement' },
        hidden: true
      },
      {
        path: 'initiate',
        name: 'receivingSettlementInitiate',
        component: () => import('@/views/receivingSettlement/initiate'),
        meta: { title: 'router.receivingSettlementInitiate', activeMenu: '/receivingSettlement' },
        hidden: true
      },
      {
        path: 'issued',
        name: 'receivingSettlementIssued',
        component: () => import('@/views/receivingSettlement/issued'),
        meta: { title: 'router.receivingSettlementIssued', activeMenu: '/receivingSettlement' },
        hidden: true
      },
      {
        path: 'receivingSettlementRecord',
        name: 'receivingSettlementRecord',
        component: () => import('@/views/receivingSettlement/record'),
        meta: { title: 'router.receivingSettlementRecord' },
        api: [api.receiving.receiptAll]
        // api: merchantType === 'proxy_crossing' ? [api.agent.receiptAll] : [api.receiving.receiptAll]
      }
    ]
  },
  {
    path: '/recepitDistribute',
    component: Layout,
    children: [
      {
        path: '',
        name: 'recepitDistribute',
        component: () => import('@/views/recepitDistribute'),
        meta: { title: 'router.recepitDistribute', icon: 'distribute' },
        api: merchantType === 'proxy_crossing' ? [api.agent.distributeAll] : [api.receiving.distributeAll],
        hidden: merchantType!== 'overseas_crossing' && merchantType!== 'proxy_crossing' ? true : false
      },
      {
        path: 'detail',
        name: 'recepitDistributeDetail',
        component: () => import('@/views/recepitDistribute/detail'),
        meta: { title: 'router.recepitDistributeDetail', icon: 'distribute', activeMenu: '/recepitDistribute' },
        hidden: true
      },
    ]
  },
  {
    path: '/setting',
    component: Layout,
    children: [
      {
        path: '',
        name: 'setting',
        component: () => import('@/views/userSetting'),
        meta: { title: 'router.setting', icon: 'setting', noCache: true }
      }
    ]
  },
  {
    path: '/',
    redirect: '/wallet'
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/register')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login')
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: () => import('@/views/login/forgot')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/views/terms')
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: () => import('@/views/privacyPolicy')
  },
  {
    path: '/materialDescription',
    name: 'materialDescription',
    component: () => import('@/views/materialDescription')
  },
  {
    path: '/cashier',
    name: 'cashier',
    component: () => import('@/views/wallet/cashier')
  },
  {
    path: '/cashierIE',
    name: 'cashierIE',
    component: () => import('@/views/wallet/cashierIE')
  },
  {
    path: '/401',
    component: () => import('@/views/401'),
    hidden: true
  },
  {
    path: '/404',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/404'),
        hidden: true
      }
    ]
  },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]
}else {
constantRoutesArray = [
  {
    path: '/certification',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'certification',
        component: () => import('@/views/certification'),
      },
      {
        path: 'audit',
        name: 'audit',
        component: () => import('@/views/certification/audit'),
      },
      {
        path: 'step',
        name: 'step',
        component: () => import('@/views/certification/step'),
      }
    ]
  },
  {
    path: '/wallet',
    component: Layout,
    children: [
      {
        path: '',
        name: 'wallet',
        component: () => import('@/views/wallet'),
        meta: { title: 'router.wallet', icon: 'multiwallet' },
        api: [api.wallet.multiAccount]
      },
      {
        path: 'detail',
        name: 'wallet_detail',
        component: () => import('@/views/wallet/list'),
        meta: { title: 'router.walletDetail', activeMenu: '/wallet' },
        hidden: true
      },
      {
        path: 'abroadList',
        name: 'wallet_detail',
        component: () => import('@/views/wallet/abroadList'),
        meta: { title: 'router.walletDetail', activeMenu: '/wallet' },
        hidden: true
      }
    ]
  },
  {
    path: '/subMerchant',
    component: Layout,
    children: [
      {
        path: '',
        name: 'subMerchant',
        component: () => import('@/views/subMerchant'),
        meta: { title: 'router.subMerchant', icon: 'sub', noCache: true},
        api: [api.agent.search]
      }
    ]
  },
  {
    path: '/transactionManage',
    name: 'transactionManage',
    component: Layout,
    meta: { title: 'router.transactionManage', icon: 'envelope' },
    children: [
      {
        path: 'recharge',
        name: 'recharge',
        component: () => import('@/views/transactionManage/recharge'),
        meta: { title: 'router.recharge' },
        api: [api.transaction.depositsSearch]
      },
      {
        path: 'overseasRecharge',
        name: 'overseasRecharge',
        component: () => import('@/views/transactionManage/overseasRecharge'),
        meta: { title: 'router.overseasRecharge' },
        api: [api.transaction.overseaList]
      },
      {
        path: 'withdrawal',
        name: 'withdrawal',
        component: () => import('@/views/transactionManage/withdrawal'),
        meta: { title: 'router.withdrawal' },
        api: [api.transaction.withdrawSearch]
      },
      {
        path: 'gateway',
        name: 'gateway',
        component: () => import('@/views/transactionManage/gateway'),
        meta: { title: 'router.gateway' },
        api: merchantType === 'proxy_crossing' ? [api.agent.gatewaySearch] : [api.transaction.gatewaySearch]
      },
      {
        path: 'authentication',
        name: 'authentication',
        component: () => import('@/views/transactionManage/authentication'),
        meta: { title: 'router.authentication' },
        api: merchantType === 'proxy_crossing' ? [api.agent.authenticationSearch] : [api.transaction.authenticationSearch]
      },
      {
        path: 'payForAnother',
        name: 'payForAnother',
        component: () => import('@/views/transactionManage/payForAnother'),
        meta: { title: 'router.payForAnother' },
        api: merchantType === 'proxy_crossing' ? [api.agent.onBehalfSearch] : [api.transaction.onBehalfSearch]
      },
      {
        path: 'scanPay',
        name: 'scanPay',
        component: () => import('@/views/transactionManage/scanPay'),
        meta: { title: 'router.scanPay' },
        api: merchantType === 'proxy_crossing' ? [api.agent.scanPaySearch] : [api.transaction.scanPaySearch]
      },
      {
        path: 'refund',
        name: 'refund',
        component: () => import('@/views/transactionManage/refund'),
        meta: { title: 'router.refund' },
        api: merchantType === 'proxy_crossing' ? [api.agent.refundSearch] : [api.transaction.refundSearch]
      },
      {
        path: 'fastPayment',
        name: 'fastPayment',
        component: () => import('@/views/transactionManage/fastPayment'),
        meta: { title: 'router.fastPayment' },
        api: merchantType === 'proxy_crossing' ? [api.agent.fastPaymentSearch] : [api.transaction.fastPaymentSearch]
      },
      {
        path: 'commitCustom',
        name: 'commitCustom',
        component: () => import('@/views/transactionManage/commitCustom'),
        meta: { title: 'router.commitCustom' },
        api: merchantType === 'proxy_crossing' ? [api.agent.commitCustomSearch] : [api.transaction.commitCustomSearch]
      },
      {
        path: 'specialFast',
        name: 'specialFast',
        component: () => import('@/views/transactionManage/specialFast'),
        meta: { title: 'router.specialFast' },
        api: merchantType === 'proxy_crossing' ? [api.agent.specialFastSearch] : [api.transaction.specialFastSearch]
      }
    ],
    hiddenNumber: true,
  },
  {
    path: '/feeManage',
    name: 'feeManage',
    component: Layout,
    meta: { title: 'router.feeManage', icon: 'feeManage' },
    children: [
      {
        path: 'detail',
        name: 'feeDetail',
        component: () => import('@/views/feeManage/detail'),
        meta: { title: 'router.feeDetail',},
        hidden: merchantType === 'proxy_crossing' ? true : false
      },
      {
        path: 'reconciliation',
        name: 'reconciliation',
        component: () => import('@/views/feeManage/reconciliation'),
        meta: { title: 'router.feeReconciliation' },
        hidden: merchantType === 'proxy_crossing' ? true : false
      },
    ]
  },
  {
    path: '/purchasePayment',
    component: Layout,
    children: [
      {
        path: '',
        name: 'purchasePayment',
        component: () => import('@/views/purchasePayment'),
        meta: { title: 'router.purchasePayment', icon: 'purchase' },
        api: merchantType === 'proxy_crossing' ? [api.agent.transactionList] : [api.purchase.transactionList]
      },
      {
        path: 'detail',
        name: 'purchasePaymentDetail',
        component: () => import('@/views/purchasePayment/detail'),
        meta: { title: 'purchasePaymentDetail', activeMenu: '/purchasePayment' },
        hidden: true
      },
      {
        path: 'order',
        name: 'purchasePaymentOrder',
        component: () => import('@/views/purchasePayment/order'),
        meta: { title: 'router.purchasePaymentOrder', activeMenu: '/purchasePayment'},
        hidden: true
      },
      {
        path: 'initiate',
        name: 'initiate',
        component: () => import('@/views/purchasePayment/initiate'),
        meta: { title: 'router.initiate', activeMenu: '/purchasePayment' },
        hidden: true
      },
    ]
  },
  {
    path: '/receivingSettlement',
    component: Layout,
    meta: { title: 'router.receivingSettlement', icon: 'ChinaY' },
    children: [
      {
        path: '',
        name: 'receivingSettlement',
        component: () => import('@/views/receivingSettlement'),
        meta: { title: 'router.receivingSettlement' },
        api: merchantType === 'proxy_crossing' ? [api.agent.receiptAll] : [api.receiving.receiptAll]
      },
      {
        path: 'order',
        name: 'receivingSettlementOrder',
        component: () => import('@/views/receivingSettlement/order'),
        meta: { title: 'router.receivingSettlementOrder', activeMenu: '/receivingSettlement' },
        hidden: true
      },
      {
        path: 'batch',
        name: 'receivingSettlementBatch',
        component: () => import('@/views/receivingSettlement/batch'),
        meta: { title: 'router.receivingSettlementBatch', activeMenu: '/receivingSettlement' },
        hidden: true
      },
      {
        path: 'detail',
        name: 'receivingSettlementDetail',
        component: () => import('@/views/receivingSettlement/detail'),
        meta: { title: 'router.receivingSettlementDetail', activeMenu: '/receivingSettlement' },
        hidden: true
      },
      {
        path: 'initiate',
        name: 'receivingSettlementInitiate',
        component: () => import('@/views/receivingSettlement/initiate'),
        meta: { title: 'router.receivingSettlementInitiate', activeMenu: '/receivingSettlement' },
        hidden: true
      },
      {
        path: 'issued',
        name: 'receivingSettlementIssued',
        component: () => import('@/views/receivingSettlement/issued'),
        meta: { title: 'router.receivingSettlementIssued', activeMenu: '/receivingSettlement' },
        hidden: true
      },
      {
        path: 'receivingSettlementRecord',
        name: 'receivingSettlementRecord',
        component: () => import('@/views/receivingSettlement/record'),
        meta: { title: 'router.receivingSettlementRecord' },
        api: [api.receiving.receiptAll]
        // api: merchantType === 'proxy_crossing' ? [api.agent.receiptAll] : [api.receiving.receiptAll]
      }
    ]
  },
  {
    path: '/overseasCollection',
    component: Layout,
    children: [
      {
        path: '',
        name: 'overseasCollection',
        component: () => import('@/views/overseasCollection'),
        meta: { title: 'router.overseasCollection', icon: 'haiwaishoukuanA' },
        api: merchantType === 'proxy_crossing' ? [api.agent.overseasReceiptAll] : [api.overseasCollection.receiptAll]
      },
      {
        path: 'initiate',
        name: 'overseasCollectionInitiate',
        component: () => import('@/views/overseasCollection/initiate'),
        meta: { title: 'router.overseasCollectionInitiate', activeMenu: '/overseasCollection' },
        hidden: true
      }
    ]
  },


  {
    path: '/recepitDistribute',
    component: Layout,
    children: [
      {
        path: '',
        name: 'recepitDistribute',
        component: () => import('@/views/recepitDistribute'),
        meta: { title: 'router.recepitDistribute', icon: 'distribute' },
        api: merchantType === 'proxy_crossing' ? [api.agent.distributeAll] : [api.receiving.distributeAll],
        hidden: merchantType!== 'overseas_crossing' && merchantType!== 'proxy_crossing' ? true : false
      },
      {
        path: 'detail',
        name: 'recepitDistributeDetail',
        component: () => import('@/views/recepitDistribute/detail'),
        meta: { title: 'router.recepitDistributeDetail', icon: 'distribute', activeMenu: '/recepitDistribute' },
        hidden: true
      },
    ]
  },
  {
    path: '/reconciliation',
    component: Layout,
    children: [
      {
        path: '',
        name: 'reconciliation',
        component: () => import('@/views/reconciliation'),
        meta: { title: 'router.reconciliation', icon: 'reconciliation', noCache: true},
        api: merchantType === 'proxy_crossing' ? [api.agent.reconciliationList] : [api.merchant.reconciliationList]
      }
    ],
    hiddenNumber: true,
  },
  {
    path: '/domesticPaid',
    component: Layout,
    children: [
      {
        path: '',
        name: 'domesticPaid',
        component: () => import('@/views/domesticPaid'),
        meta: { title: 'router.domesticPaid', icon: 'paid' },
        api: [api.behalf.batchSearch]
      },
      {
        path: 'detail',
        name: 'domesticPaidDetail',
        component: () => import('@/views/domesticPaid/detail'),
        meta: { title: 'router.domesticPaidDetail', icon: 'paid', activeMenu: '/domesticPaid' },
        hidden: true
      }
    ]
  },
  {
    path: '/virtualCard',
    name: 'virtualCard',
    component: Layout,
    meta: { title: 'router.virtualCard', icon: 'feeManage' },
    children: [
      {
        path: 'denomination',
        name: 'denomination',
        component: () => import('@/views/virtualCard/denomination'),
        meta: { title: 'router.denomination' },
        api: merchantType === 'proxy_crossing' ? [api.agent.vaAccountList] : [api.virtual.list],
      },
      {
        path: 'recharge',
        name: 'recharge',
        component: () => import('@/views/virtualCard/recharge'),
        meta: { title: 'router.cardRecharge', icon: 'vcc' },
        hidden: true
      },
      {
        path: 'apply',
        name: 'apply',
        component: () => import('@/views/virtualCard/apply'),
        meta: { title: 'router.cardApply', icon: 'vcc' },
        hidden: true
      },
      {
        path: 'details',
        name: 'details',
        component: () => import('@/views/virtualCard/details'),
        meta: { title: 'router.cardDetails', icon: 'vcc' },
        hidden: true
      },
      {
        path: 'virtualCard',
        name: 'virtualCard',
        component: () => import('@/views/virtualCard'),
        meta: { title: 'router.virtualCardManagement' },
        api: merchantType === 'proxy_crossing' ? [api.agent.vaAccountList] : [api.virtual.list]
      },
      {
        path: 'applyMulti',
        name: 'applyMulti',
        component: () => import('@/views/virtualCard/applyMulti'),
        meta: { title: 'router.applyMulti' },
        api: [api.virtual.batchMultiCreate],
        hidden: virtualNumber2.filter(item => item === merchantNumber)[0] ? false : true,
      },
      {
        path: 'multiVirtualCard',
        name: 'multiVirtualCard',
        component: () => import('@/views/virtualCard/multiVirtualCard'),
        meta: { title: 'router.multiVirtualCard' },
        api: [api.virtual.multiList],
        hidden: virtualNumber2.filter(item => item === merchantNumber)[0] ? false : true,
      },
      {
        path: 'multiDenomination',
        name: 'multiDenomination',
        component: () => import('@/views/virtualCard/multiDenomination'),
        meta: { title: 'router.multiDenomination' },
        api: [api.virtual.multiDenominationList],
        hidden: virtualNumber2.filter(item => item === merchantNumber)[0] ? false : true,
      },
      {
        path: 'multiDetails',
        name: 'multiDetails',
        component: () => import('@/views/virtualCard/multiDetails'),
        meta: { title: 'router.multiDetails', icon: 'vcc' },
        hidden: true
      },
      // {
      //   path: 'electronicCard',
      //   name: 'electronicCard',
      //   component: () => import('@/views/virtualCard/electronicCard'),
      //   meta: { title: '电商卡' },
      //   hidden: virtualNumber.filter(item => item === merchantNumber)[0]?false:true
      //   // api: merchantType === 'proxy_crossing' ? [api.virtual.virtualDskList] : [api.virtual.virtualDskList]
      // }
    ]
  },
  {
    path: '/overseasReceipt',
    name: 'overseasReceipt',
    component: Layout,
    meta: { title: 'router.overseasReceipt', icon: 'feeManage' },
    children: [
      {
        path: 'denomination',
        name: 'denomination',
        component: () => import('@/views/overseasReceipt/settlement'),
        meta: { title: 'router.settlement' },
        api: merchantType === 'proxy_crossing' ? [api.overseasReceipt.fcasettlebatch] : [api.overseasReceipt.fcasettlebatch]
      },
      {
        path: 'orderList',
        name: 'orderList',
        component: () => import('@/views/overseasReceipt/orderList'),
        meta: { title: 'router.orderList' },
        api: merchantType === 'proxy_crossing' ? [api.overseasReceipt.orderDetails] : [api.overseasReceipt.orderDetails]
      },
      {
        path: 'refund',
        name: 'refund',
        component: () => import('@/views/overseasReceipt/refund'),
        meta: { title: 'router.overseasRefund' },
        api: merchantType === 'proxy_crossing' ? [api.overseasReceipt.refundList] : [api.overseasReceipt.refundList]
      },
      {
        path: 'dispute',
        name: 'dispute',
        component: () => import('@/views/overseasReceipt/dispute'),
        meta: { title: 'router.dispute' },
        api: merchantType === 'proxy_crossing' ? [api.overseasReceipt.dispute] : [api.overseasReceipt.dispute]
      },
    ]
  },
  {
    path: '/permission',
    component: Layout,
    children: [
      {
        path: '',
        name: 'permission',
        component: () => import('@/views/permission'),
        meta: { title: 'router.permission', icon: 'key' }
      },
      {
        path: 'bankRecord',
        name: 'bankRecord',
        component: () => import('@/views/permission/bankRecord'),
        meta: { title: 'bankRecord', icon: 'key', activeMenu: '/permission' },
        hidden: true
      }
    ],
    hiddenNumber: true,
  },
  {
    path: '/setting',
    component: Layout,
    children: [
      {
        path: '',
        name: 'setting',
        component: () => import('@/views/userSetting'),
        meta: { title: 'router.setting', icon: 'setting', noCache: true }
      }
    ]
  },
  {
    path: '/',
    redirect: '/wallet'
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/register')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login')
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: () => import('@/views/login/forgot')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/views/terms')
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: () => import('@/views/privacyPolicy')
  },
  {
    path: '/materialDescription',
    name: 'materialDescription',
    component: () => import('@/views/materialDescription')
  },
  {
    path: '/cashier',
    name: 'cashier',
    component: () => import('@/views/wallet/cashier')
  },
  {
    path: '/cashierIE',
    name: 'cashierIE',
    component: () => import('@/views/wallet/cashierIE')
  },
  {
    path: '/401',
    component: () => import('@/views/401'),
    hidden: true
  },
  {
    path: '/404',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/404'),
        hidden: true
      }
    ]
  },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]
}
export const constantRoutes = constantRoutesArray
const createRouter = () => new VueRouter({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
